import React, { Fragment, Component } from 'react';
import moment from 'moment';
import { CustomInput, Label } from 'reactstrap';
import dates from 'react-big-calendar/lib/utils/dates';
import { navigate } from 'react-big-calendar/lib/utils/constants';
import { inRange } from 'react-big-calendar/lib/utils/eventLevels';
import { isSelected } from 'react-big-calendar/lib/utils/selection';
import AgendaListItemIcon from '~/components/agendaListItemIcon/agendaListItemIcon';
import AgendaActions from '~/containers/agendaActions/agendaActions';
import LotStatusText from '~/components/lotStatusText/lotStatusText';

const dayAndIdxToKey = (day, idx) => {
  return `${moment(day).format('YYYYMMDD')}${idx}`;
};

class Agenda extends Component {
  static defaultProps = {
    length: 30
  };

  state = {
    selectedEvents: {}
  };

  checkBoxClicked = (e, event, day, idx) => {
    e.preventDefault();
    e.stopPropagation();
    const { selectedEvents } = this.state;
    const key = dayAndIdxToKey(day, idx);
    // Bit inaccurate as maybe the event prop could change dynamically, but for the moment
    // save checked/unchecked state as the index of the event array plus lot id. Will need
    // to reset when days change
    if (selectedEvents[key]) {
      delete selectedEvents[key];
    } else {
      selectedEvents[key] = event;
    }

    this.setState({
      selectedEvents: { ...selectedEvents }
    });
  };

  deselectEvents = () => {
    this.setState({
      selectedEvents: {}
    });
  };

  render() {
    let { length, date, events, accessors, localizer } = this.props;
    const { selectedEvents } = this.state;
    let { messages } = localizer;
    let end = dates.add(date, length, 'day');

    let range = dates.range(date, end, 'day');

    events = events
      .filter(event => inRange(event, date, end, accessors))
      .sort((a, b) => +accessors.start(a) - +accessors.start(b));

    return (
      <Fragment>
        <div className="flex justify-end mb2">
          <AgendaActions selectedEvents={selectedEvents} refreshList={this.deselectEvents} />
        </div>
        <div className="rbc-agenda-view">
          {events.length !== 0 ? (
            <Fragment>
              <div className="rbc-agenda-content" ref="content">
                <table className="rbc-agenda-table">
                  <tbody ref="tbody">{range.map((day, idx) => this.renderDay(day, events, idx))}</tbody>
                </table>
              </div>
            </Fragment>
          ) : (
            <span className="rbc-agenda-empty">{messages.noEventsInRange}</span>
          )}
        </div>
      </Fragment>
    );
  }

  renderDay = (day, events, dayKey) => {
    let {
      onSelectEvent,
      selected,
      getters,
      accessors,
      localizer,
      components: { date: AgendaDate }
    } = this.props;

    const { selectedEvents } = this.state;
    events = events.filter(e => inRange(e, dates.startOf(day, 'day'), dates.endOf(day, 'day'), accessors));

    return events.map((event, idx) => {
      let title = accessors.title(event);
      let end = accessors.end(event);
      let start = accessors.start(event);

      const userProps = getters.eventProp(event, start, end, isSelected(event, selected));

      let dateLabel = idx === 0 && localizer.format(day, 'agendaDateFormat');
      let first =
        idx === 0 ? (
          <td rowSpan={events.length} className="rbc-agenda-date-cell">
            {AgendaDate ? <AgendaDate day={day} label={dateLabel} /> : dateLabel}
          </td>
        ) : (
          false
        );

      return (
        <tr
          key={dayKey + '_' + idx}
          onClick={() => onSelectEvent(event)}
          className={`${userProps.className} pointer row-hover`}
          style={userProps.style}
        >
          {first}
          <td className="rbc-agenda-event-cell">
            <div className="flex">
              <div className="flex-grow-1 flex items-center">
                <Label onClick={e => this.checkBoxClicked(e, event, day, idx)}>
                  <CustomInput
                    id="headerCheck"
                    readOnly
                    checked={!!selectedEvents[dayAndIdxToKey(day, idx)]}
                    type="checkbox"
                    className="checkbox center"
                  />
                </Label>
                <AgendaListItemIcon event={event} />
                {title}
              </div>
              <div className="flex items-center">
                <LotStatusText status={event.resource.lot.status} capitalise colour />
              </div>
            </div>
          </td>
        </tr>
      );
    }, []);
  };
}

Agenda.range = (start, { length = Agenda.defaultProps.length }) => {
  let end = dates.add(start, length, 'day');
  return { start, end };
};

Agenda.navigate = (date, action, { length = Agenda.defaultProps.length }) => {
  switch (action) {
    case navigate.PREVIOUS:
      return dates.add(date, -length, 'day');
    case navigate.NEXT:
      return dates.add(date, length, 'day');
    default:
      return date;
  }
};

Agenda.title = (start, { length = Agenda.defaultProps.length, localizer }) => {
  return `${moment(start).format('ddd Do MMM')} - ${moment(start)
    .add(7, 'day')
    .format('ddd Do MMM')}`;
};

export default Agenda;



// WEBPACK FOOTER //
// ./src/components/agendaList/agendaList.jsx